export const chartColors = [
  "#3a3dee",
  "#07b9d5",
  "#71717a",
  "#a855f7",
  "#ebbd05",
  "#ef4343",
  "#82cb15",
  "#ec4699",
] as const;
